import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../.././../environments/environment';
import {Observable} from 'rxjs';

const apiUrl: string = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class IntegracionesService {

  constructor(private http: HttpClient) {
  }

  obtenerListaIntegraciones(datos): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/integraciones/list/`, datos);
  }

  obtenerListaIntegracionesVirtuales(datos): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/integraciones/canales-virtuales/canal-fisico/`, datos);
  }

  obtenerCanalPorNombre(datos): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/integraciones/search/canal/`, datos);
  }

  obtenerFormasEntregaBodegas(datos): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/integraciones/search/formas-entrega/bodegas`, datos);
  }

  obtenerTodaListaIntegraciones(datos): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/integraciones/list/todos`, datos);
  }

  obtenerListaUbicacionesIntegraciones(datos): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/integraciones/ubicaciones/list/`, datos);
  }

  obtenerListaIntegracionesPublic(datos): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/integraciones/list/public/`, datos);
  }

  obtenerUbicacionCategoriasIntegraciones(datos): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/integraciones/list/ubicacion/categorias`, datos);
  }

  insertarIntegracion(datos): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/integraciones/create/`, datos);
  }

  editarIntegracion(datos): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/integraciones/update/${datos.id}`, datos);
  }

  editarBodegaCentralIntegracion(datos): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/integraciones/update/bodega/central/${datos.id}`, datos);
  }

  editarIntegracionFormData(datos: FormData): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/integraciones/update/${datos.get('id')}`, datos);
  }

  eliminarIntegracion(id): Observable<any> {
    return this.http.delete<any>(`${apiUrl}/adm/integraciones/delete/${id}`);
  }

  activarIntegracion(id): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/integraciones/activar/${id}`, {});
  }

  obtenerIntegracion(id): Observable<any> {
    return this.http.get<any>(`${apiUrl}/adm/integraciones/listOne/${id}`);
  }

  //MONITOREO
  obtenerMonitoreoPedidos(datos): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/monitorio/pedidos/list/`, datos);
  }

  //IMAGENES
  eliminarImagen(id) {
    return this.http.delete<any>(`${apiUrl}/adm/integraciones/imagen/delete/${id}`);
  }

  //LANDING
  obtenerListaLandingIntegraciones(datos): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/integraciones/landing/list/`, datos);
  }

  insertarLandingIntegracion(datos): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/integraciones/landing/create/`, datos);
  }

  editarLandingIntegracion(datos: FormData): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/integraciones/landing/update/${datos.get('id')}`, datos);
  }

  eliminarLandingIntegracion(id): Observable<any> {
    return this.http.delete<any>(`${apiUrl}/adm/integraciones/landing/delete/${id}`);
  }

  obtenerLandingIntegracion(id): Observable<any> {
    return this.http.get<any>(`${apiUrl}/adm/integraciones/landing/listOne/${id}`);
  }

  //CONFIGURACION LOGIN
  obtenerListaConfiguracionLoginIntegraciones(datos): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/integraciones/configuracion-login/list/`, datos);
  }

  insertarConfiguracionLoginIntegracion(datos): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/integraciones/configuracion-login/create/`, datos);
  }

  editarConfiguracionLoginIntegracion(datos: FormData): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/integraciones/configuracion-login/update/${datos.get('id')}`, datos);
  }

  obtenerConfiguracionLoginIntegracion(id): Observable<any> {
    return this.http.get<any>(`${apiUrl}/adm/integraciones/configuracion-login/listOne/${id}`);
  }

  obtenerConfiguracionLoginPorIntegracion(datos): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/integraciones/configuracion-login/search/`, datos);
  }

  //CRUD DE RANGO COMISIONES
  obtenerListaRangoComisiones(datos): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/integraciones/rango-comisiones/list/`, datos);
  }

  insertarRangoComisiones(datos): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/integraciones/rango-comisiones/create/`, datos);
  }

  editarRangoComisiones(datos: FormData): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/integraciones/rango-comisiones/update/${datos.get('id')}`, datos);
  }

  eliminarRangoComisiones(id): Observable<any> {
    return this.http.delete<any>(`${apiUrl}/adm/integraciones/rango-comisiones/delete/${id}`);
  }

  obtenerRangoComisiones(id): Observable<any> {
    return this.http.get<any>(`${apiUrl}/adm/integraciones/rango-comisiones/listOne/${id}`);
  }

}
